import { connectorAPI } from 'actions/connector'

import { appActions, appSelectors } from '../../redux/reducers/app'
import store from '../../redux/store'
import { appConnector } from './singleton'

async function onLinkedDetect() {
	const state = store.getState()

	const isAuth = appSelectors.auth(state) === 'auth'

	if (isAuth) {
		const value =
			await appConnector.auth.isSignedInUnderAssociatedLinkedInProfile()

		const linkedStatusAction = appActions.setAssociatedLinkedInProfile(
			Boolean(value)
		)
		store.dispatch(linkedStatusAction)
	}

	const hasLinked = appActions.changeLinkedInAuthStatus(true)
	store.dispatch(hasLinked)
}

function onLinkedInSignedOut() {
	const notLinkedAction = appActions.changeLinkedInAuthStatus(false)
	store.dispatch(notLinkedAction)
}

async function onSnailyProfileChange() {
	const state = store.getState()

	const hours = appSelectors.appProfile(state)?.workingHoursSet

	/*if profile is completely filled*/
	if (hours) {
		await connectorAPI.getSnailyProfile()
	}

	await connectorAPI.setUpInit()
}

function onSnailySignIn() {
	const state = store.getState()

	const token = appSelectors.token(state)

	if (!token) {
		connectorAPI.setUpInit()
	}
}

function saveToRedux() {
	const saveAction = appActions.createConnector(appConnector)
	store.dispatch(saveAction)
}

function setUpEvents() {
	appConnector.eventHandlers.addLinkedInSignedOutEventHandler(
		onLinkedInSignedOut
	)
	appConnector.eventHandlers.addLinkedInProfileDetectedHandler(onLinkedDetect)

	appConnector.eventHandlers.addSnailySignedInEventHandler(onSnailySignIn)

	appConnector.eventHandlers.addSnailyProfileChangedEventHandler(
		onSnailyProfileChange
	)
}

export { saveToRedux, setUpEvents }
